<template>
  <div class="profile cart">
    <div class="card profile-info full-height">
      <div class="card-body">
        <h2>Карточка товара</h2>
        <button class="grey-button my-4" @click="addProduct()">Создать карточку</button>
        <h2 class="mt-4">Мои карточки</h2>
        <div class="filter-container">
          <div class="dropdown">
            <button class="grey-button mt-2 mb-2" @click="toggleDropdown">
              Выбрать категории
              <span v-if="selectedCategories.length">({{ selectedCategories.length }})</span>
            </button>

            <!-- Выпадающий список -->
            <div v-if="isOpen" class="dropdown-content">
              <div v-for="category in categories" :key="category.id" class="dropdown-item">
                <input
                  :id="'category-' + category.id"
                  v-model="selectedCategories"
                  type="checkbox"
                  :value="category.id"
                />
                <label :for="'category-' + category.id">{{ category.name }}</label>
              </div>
            </div>
          </div>
          <div v-if="selectedCategories.length" class="selected-categories">
            <span>Выбранные категории:</span>
            <div class="filter-tags">
              <div v-for="category in selectedCategories" :key="category" class="filter-tag">
                {{ getCategoryName(category) }}
              </div>
            </div>
          </div>
        </div>
        <div class="products-container mt-4">
          <div class="product-list row gy-4">
            <NewProductCard v-for="(item, index) in filteredProducts" :key="index" :product="item" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, onMounted, computed, ref, watch } from 'vue';
  import NewProductCard from '../../components/Profile/NewProductCard.vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import MarketplaceService from '../../services/marketplace';
  import productCategoriesService from '@/services/products';

  export default defineComponent({
    name: 'Products',
    components: {
      NewProductCard,
    },
    setup() {
      const store = useStore();
      const router = useRouter();
      const loggedIn = computed(() => store.state.auth.status.loggedIn);
      const products = ref([]);
      const isLoading = ref(false);

      const route = useRoute();
      const mode = ref('products');
      const categories = ref([]);
      const selectedCategories = ref([]);
      const isOpen = ref(false);

      const toggleDropdown = () => {
        isOpen.value = !isOpen.value;
      };

      const getProducts = async () => {
        isLoading.value = true;
        const me = await store.dispatch('user/me');

        MarketplaceService.companyRepresentative(me.id, route.query.page || 1).then((res) => {
          products.value = res;
          isLoading.value = false;
        });
      };

      const addProduct = () => {
        router.push('/profile/products/add');
      };

      const getCategories = () => {
        productCategoriesService.all().then((res) => {
          categories.value = res;
        });
      };

      const getCategoryName = (categoryId) => {
        const category = categories.value.find((cat) => cat.id === categoryId);
        return category ? category.name : 'Неизвестная категория';
      };

      // Фильтрация продуктов по выбранным категориям
      const filteredProducts = computed(() => {
        if (selectedCategories.value.length === 0) {
          return products.value.result; // Показываем все продукты, если категории не выбраны
        }
        return products.value.result.filter((product) => selectedCategories.value.includes(product.category.id));
      });

      onMounted(async () => {
        if (!loggedIn.value) {
          router.push('/');
        } else {
          getProducts();
          getCategories();
          isLoading.value = true;
        }
      });

      const selectMode = (select) => {
        mode.value = select;
        getProducts();
      };

      watch(route, () => {
        getProducts();
      });

      return {
        products,
        filteredProducts,
        selectedCategories,
        categories,
        isOpen,
        selectMode,
        getProducts,
        addProduct,
        getCategoryName,
        toggleDropdown,
      };
    },
  });
</script>

<style scoped lang="scss">
  .dropdown {
    position: relative;

    display: inline-block;
  }

  .dropdown-button {
    padding: 10px 20px;

    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
  }

  .dropdown-content {
    position: absolute;
    z-index: 1;

    display: block;
    min-width: 200px;
    max-height: 200px;
    padding: 10px;
    overflow-y: auto;

    background-color: white;
    border: 1px solid #ccc;
  }

  .dropdown-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }

  .dropdown-item label {
    margin-left: 5px;
  }

  .selected-categories {
    .filter-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }

    .filter-tag {
      display: flex;
      gap: 5px;
      align-items: center;
      padding: 5px 10px;

      background-color: #f1f1f1;
      border-radius: 20px;

      button {
        font-size: 14px;

        background: none;
        border: none;
        cursor: pointer;
      }
    }
  }
</style>
